import { useQuery } from 'react-query';

import * as dealApi from 'resources/deal/deal.api';

const getDealsByTeamId = async (teamId) => {
  const deals = await dealApi.getDealsByTeamId({ teamId });
  return deals;
};

export default function useDealsByTeamId(teamId, queryOptions) {
  return useQuery(
    ['deal.getByTeamId', teamId],
    () => getDealsByTeamId(teamId),
    queryOptions,
  );
}
